import React, { createContext, useEffect, useState } from "react";
import styled from "styled-components";
import { ScrollRestoration, useLocation, useNavigate } from "react-router-dom";
import AdministratorHeader from "../combinations/Administrator/AdministratorHeader";
import { GetAdministratorSession200Response } from "../../../api/v1";
import { api } from "../../../api";
import Flash from "../parts/Flash";
import Footer from "../combinations/Footer";

export const SessionContext =
  createContext<GetAdministratorSession200Response>(null);

type AdministratorLayoutComponentProps = {
  children: React.ReactNode;
};

const AdministratorLayoutStyle = styled.div`
  background: #f2f0e9;
  font-family: "Noto Sana JP", sans-serif;
  min-height: 100vh;
`;

const AdministratorLayout: React.FC<AdministratorLayoutComponentProps> = ({
  children,
}) => {
  const navigate = useNavigate();
  const [session, setSession] =
    useState<GetAdministratorSession200Response>(null);
  const location = useLocation();
  const message = location.state?.message;
  const level = location.state?.level;

  useEffect(() => {
    api
      .getAdministratorSession()
      .then((response) => {
        setSession(response.data);
      })
      .catch(() => {
        navigate("/administrator/login");
      });
  }, []);

  if (session)
    return (
      <SessionContext.Provider value={session}>
        <AdministratorLayoutStyle>
          <AdministratorHeader />
          {level && <Flash level={level} message={message} />}
          {children}
          <Footer backgroundColor="#f2f0e9" />
        </AdministratorLayoutStyle>
        <ScrollRestoration />
      </SessionContext.Provider>
    );

  return;
};
export default AdministratorLayout;
